module.exports = __webpack_public_path__ + "static/media/mynaghi-loader.09a10bf7.gif";